export const catalog_matrix = [
  {form_key:'pre_position_id', catalog_key:'client_user_positions'},
  {form_key:'pre_area_id', catalog_key:'client_user_areas'},
  {form_key:'pre_contact_medium_id', catalog_key:'client_contact_mediums'},
  //{form_key:'pre_responsible_id', catalog_key:'none', propname:'users'},
]